<template>
  <div class="table-responsive outgoing-cargos">
    <table class="table table-striped">
      <thead>
      <tr>
        <th class="w-5"></th>
        <th class="w-25">
          {{ $t('shopfloor.teamlead.unloading.vdh.reference') }}
        </th>
        <th  class="w-25">{{ $t('shopfloor.teamlead.unloading.reference') }}</th>
        <th class="w-10">{{ $t('shopfloor.teamlead.unloading.startTime') }}</th>
        <th class="w-25">
          {{ $t('shopfloor.teamlead.unloading.vdh.clearedTitle') }}
        </th>
        <th class="w-40 text-center">
          <i @click="showDone = !showDone; saveSetting();" class="far done-toggler"
             :class="!showDone ? 'fa-toggle-off' : 'fa-toggle-on'"/>
          <!--          <i @click="toggleInfoModal()" class="fal fa-question-circle float-right"/>-->
        </th>
        <th class="w-20">{{ $t('shopfloor.teamlead.unloading.incomingCargo.eta') }}</th>
        <th class="w-5"></th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(incomingCargo,idx) in cargoBySearch">
        <tr :key="idx+1"
            :set="progress = getProgress(orderProductsPerCargo(incomingCargo))"
            @click="proceedUnloading(incomingCargo)"
            v-if="isNotEmpty(getProgress(orderProductsPerCargo(incomingCargo)))"
            :class="'etd-before'"
            style="cursor:pointer"
            v-show="  !getProgress(orderProductsPerCargo(incomingCargo)).fullyPicked ||  (getProgress(orderProductsPerCargo(incomingCargo)).fullyPicked == true && getProgress(orderProductsPerCargo(incomingCargo)).fullyPicked  ==  showDone)">
          <td class="cargo-status-icon">
            <cargo-status-icon
                :status="incomingCargo.startTime &&  !progress.fullyPicked ? 'unloading' : (progress.fullyPicked ? 'done' : 'waiting') "
            />

          </td>
          <td>
            {{ incomingCargo.reference }}

          </td>
          <td v-if="incomingCargo.startTime && progress.unloaded">{{
              incomingCargo.startTime.seconds |
                  firebaseTimestampTime
            }}
          </td>

          <td>
            <div v-if="incomingCargo.cleared">
              <i v-if="progress.fullyPicked" class="fas fa-check green"/>
              <i v-if="!progress.fullyPicked" class="fas fa-check gray"/>
            </div>
          </td>
          <td>
            <ProgressBarIncomingCargo :progress="progress"/>
          </td>
          <td v-if="incomingCargo.estimatedTimeOfArrival">{{ formatIncoming(incomingCargo.estimatedTimeOfArrival) }}
            <!--          <i v-if="checkETA(incomingCargo)" class="fas fa-exclamation-triangle"/>-->
          </td>
          <td>
            <i class="fas fa-chevron-right"/>
          </td>
        </tr>

      </template>
      </tbody>
    </table>
  </div>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';

import ProgressBarIncomingCargo from "../../components/ProgressBarIncomingCargo";
import CargoStatusIcon from "../../components/CargoStatusIcon";

export default {
  components: {
    ProgressBarIncomingCargo,
    CargoStatusIcon
  },
  data() {
    return {
      showDone: sessionStorage.getItem('DoneToggleUnloading') === 'false' ? false : true,
      tooltip: true,
      currentTime: null,
      searchCargo: '',
      done: false,
      time: moment()
    };
  },
  computed: {
    ...mapGetters('incomingCargo', ['getIncomingCargos']),
    ...mapGetters('incomingOrderProducts', ['getProducts']),
    ...mapGetters(['getAPICompanyID']),
    ...mapGetters('users', ['getMeBasic']),
    cargoBySearch() {
      const maxDaysOld = 1;
      let cargos = this.getIncomingCargos;
      let cargoList = cargos.filter((cargo) => {
        if (moment().subtract(maxDaysOld, 'days').isSameOrBefore(moment(cargo.estimatedTimeOfArrival.toDate())) && moment().endOf('day').isAfter(cargo.estimatedTimeOfArrival.toDate())) {
          return true
        }
      });
      return _.orderBy(cargoList, ['estimatedTimeOfArrival', 'status'], ['desc', 'desc'])
    }
  },
  methods: {
    isNotEmpty(progress) {
      return (progress && !(progress.unloaded === 0 && progress.notUnloaded === 0 && progress.unscanable == 0));
    },

    saveSetting() {
      sessionStorage.setItem('DoneToggleUnloading', this.showDone ? 'true' : 'false');
    },
    toggleInfoModal() {
      let html = '<div class="legend-block">' +
          '<ul>' +
          '<li><div class="block"><i @click="showDone = !showDone" class="far fa-toggle-off done-toggler"></i></div>' + this.$root.$t('shopfloor.teamlead.unloading.legend.toggle') + '</li>' +
          '<li><div class="block green"></div>' + this.$root.$t('shopfloor.teamlead.unloading.legend.green') + '</li>' +
          '<li><div class="block orange"></div>' + this.$root.$t('shopfloor.teamlead.unloading.legend.orange') + '</li>' +
          '<li><div class="block blue"></div>' + this.$root.$t('shopfloor.teamlead.unloading.legend.blue') + '</li>' +
          '<li><div class="block white"></div>' + this.$root.$t('shopfloor.teamlead.unloading.legend.white') + '</li>' +
          '</ul>' +
          '</div>';

      this.$swal({
        customClass: 'm-swal-load-unload',
        width: '80%',
        allowEscapeKey: true,
        allowOutsideClick: true,
        title: this.$root.$t('shopfloor.teamlead.unloading.legendTitle'),
        html: html,
        showConfirmButton: true,
        cancelButtonText: this.$root.$t('ui.close')
      });
    },
    getProgress(incomingOrderProducts) {
      let total = 0;
      let unloaded = 0;
      let unscanable = 0;
      _.each(incomingOrderProducts, product => {
        if (!product.retour) {
          total += parseInt(product.amount)
          if (product.amountUnloaded && product.amount >= product.amountUnloaded) {
            unloaded += product.amountUnloaded
          }
          if (product.barcodeUnreadable) {
            unscanable += product.amount;
          }

        }
      })
      return {
        total: total === 0 ? 1 : total,
        unloaded,
        unscanable,
        notUnloaded: (total - unloaded),
        fullyPicked: (total - unloaded <= 0),

      }
    },
    proceedUnloading(cargo) {

        this.$router.push({
          name: 'teamlead-order-handling-unloading',
          params: {cargo: cargo}
        });

    },
    formatIncoming(arrival) {
      return moment(arrival.toDate()).format('DD/MM HH:mm')
    },
    formatETA(dateFromFirebase) {
      return moment(dateFromFirebase.toDate()).format('DD/MM HH:mm')
    },
    orderProductsPerCargo(cargo) {
      return _.filter(this.getProducts, prod => {
        if (cargo.truckNumber === '054'){
          // console.log(prod.cargoId, cargo.id)
        }
        return prod.cargoId == cargo.id || prod.cargoNumber == cargo.cargoNumber
      })
    },
    removeFocus() {
      this.$refs.search.blur();
    },

    getETA(timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate()).format('DD/MM/YY');
      } else {
        return '';
      }
    },
    checkETA(incoming) {

      let now = this.time
      if (now && incoming.estimatedTimeOfArrival)
        return now.isAfter(moment(incoming.estimatedTimeOfArrival.toDate())) && incoming.status != 'done';
    },


  },
  watch: {
    search(newV) {
      localStorage.setItem('unloading-unloaded-overview', newV)
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (!this.isLoading) {
      if (to.name !== 'unloading-cargo-products') {
        await this.$store.dispatch('resetStoreModules', [
          'incomingOrderProducts',
        ]);
      }
      next();
    }
  },

  async created() {
    setInterval(() => {
      this.time = moment()
    }, 5000)

    this.loading = true
    if (!this.getProducts.length) {
      // await this.$store.dispatch('initDataForPage', ['incomingOrderProducts'])
      await this.$store.dispatch('initDataForPage',[{module:'incomingOrderProducts',where:['estimatedTimeOfArrival','>=',moment().subtract(5,'day').toDate()]}])
    }
    this.isLoading = false
  }
};
</script>

<style lang="scss" scoped>

.row {
  padding-right: 0;
  padding-left: 0
}

.green {
  color: #00b954;
}

.gray {
  color: gray;
}
</style>
